import React from 'react';
import { ItemCreation } from '~/ModularComponents';
import { CreateStudioSection } from './CreateStudioSections';
import { IOrgStudios } from './Studio.model';
import { useStudioCreation } from './useStudioCreation';

export const StudioCreation = () => {
  const {
    onSave,
    initialValues,
    isLoading,
    validationSchema,
    modalTitle,
    validate,
    error,
  } = useStudioCreation();

  return (
    <ItemCreation<IOrgStudios>
      onSave={onSave}
      initialValues={initialValues}
      validate={validate}
      isLoading={isLoading}
      validationSchema={validationSchema}
      modalTitle={modalTitle}
      networkErrors={error || undefined}
    >
      <CreateStudioSection />
    </ItemCreation>
  );
};
